import { render, staticRenderFns } from "./tableForm.vue?vue&type=template&id=6db8a9e0&scoped=true&"
import script from "./tableForm.vue?vue&type=script&lang=js&"
export * from "./tableForm.vue?vue&type=script&lang=js&"
import style0 from "./tableForm.vue?vue&type=style&index=0&id=6db8a9e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db8a9e0",
  null
  
)

export default component.exports